// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcumbs_breadcrumbs__bpmxG"};